import React, { useRef, useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";

import Header from "./Header";
import Footer from "./Footer";
import FooterHighlights from "./FooterHighlights";

const FontLayout = () => {
  const location = useLocation();
  const isLoginPage = location.pathname === "/login";

  const headerRef = useRef(null);
  const [headerHeight, setHeaderHeight] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const updateHeight = () => {
      setIsMobile(window.innerWidth <= 768);
      if (headerRef.current) {
        setHeaderHeight(headerRef.current.offsetHeight);
      }
    };

    updateHeight();

    const ro = new ResizeObserver(updateHeight);
    if (headerRef.current) ro.observe(headerRef.current);
    window.addEventListener("resize", updateHeight);

    return () => {
      ro.disconnect();
      window.removeEventListener("resize", updateHeight);
    };
  }, [isLoginPage]);

  return (
    <>
      <style>{`
        * { box-sizing: border-box; }
        body { margin: 0; padding: 0; overflow-x: hidden; }
      `}</style>

      {/* HEADER — fixed on desktop, relative (flows with page) on mobile */}
      {!isLoginPage && (
        <div
          ref={headerRef}
          style={{
            position: isMobile ? "relative" : "fixed",
            top: 0,
            left: 0,
            width: "100%",
            zIndex: 1200,
            background: "#fff",
          }}
        >
          <Header />
        </div>
      )}

      {/* PAGE CONTENT
          Desktop: pad by exact header height so content isn't hidden under fixed header
          Mobile:  no padding needed — header flows above content naturally */}
      <main
        style={{
          minHeight: "100vh",
          paddingTop:
            isLoginPage || isMobile ? "0px" : `${headerHeight}px`,
        }}
      >
        <Outlet />
      </main>

      {!isLoginPage && (
        <>
          <FooterHighlights />
          <Footer />
        </>
      )}
    </>
  );
};

export default FontLayout;